import { SmartPowerSettingsFormModel } from 'src/Libs/smart-power/models'
import { SmartPowerSettingsUpdateDto } from 'src/Libs/smart-power/api'

const settingsFormToDtoTransformer = (formValues: SmartPowerSettingsFormModel): SmartPowerSettingsUpdateDto => {
  return {
    emsPowersaveEnabled: formValues.emsPowersaveEnabled,
    emsPowerLimitsUsed: formValues.emsPowerLimitsUsed,
    emsMaxChargePower: formValues.emsMaxChargePower,
    emsMaxDischargePower: formValues.emsMaxDischargePower,
    emsDischargeStartPower: formValues.emsDischargeStartPower,
  } as SmartPowerSettingsUpdateDto
}
export default settingsFormToDtoTransformer
